 
import * as React from 'react';
import { Outlet } from 'react-router-dom';
 

export default function Layout2( ) {

    return (
        <>
             
            <div className="container  vh-100 d-flex  mt-3 justify-content-center">

                <div className='w-100'>
                    <div className="row align-items-center  ">
                        <div className="col-md-10 mx-auto col-lg-5" id="colMain">                             
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            {/*
            <div className="fixed-bottom">
                <div className='d-flex justify-content-center pb-3 text-white fs1'>
                    تحت معاونت علوم، تحقیقات و فناوری ناجا و پلیس پیشگیری
                </div>
            </div>*/}


        </>
    );

}